import React, {useState, useEffect} from 'react'

import classes from './ObjectiveBar.module.css'
import AppState from '../../js/AppState';
import clsx from 'clsx';
import { states } from 'react-sdk/Objectives/ObjectiveFile';
import { observer } from 'mobx-react-lite';
import PlayAudio from '../shared/PlayAudio/PlayAudio';
import { FaPlay, FaVolumeHigh } from 'react-icons/fa6';
import Button from '../shared/Button/Button';

const ObjectiveBar = () => {



  return (
    <div className={classes.ObjectiveBar}>
      <div className={classes.obj_timeline}>
        {AppState.objectives.activeRootObjectives[0].children.map(obj => {
          let audio = obj.sourceObjective.line.get("Audio")
          return (
            <div key={obj.id} className={clsx(obj.state === states.ACTIVE && classes.current)} >
              {obj.state === states.ACTIVE &&
              <PlayAudio audio={audio}>
                {(playing, handleClick) => {
                  return (
                  <div className={clsx(classes.obj_name)} onClick={handleClick}>
                    <Button icon={playing ? <FaVolumeHigh/> : <FaPlay />} className={classes.play_button} />
                    {/*playing ? <FaVolumeHigh/> : <FaPlay />*/}
                    <span dangerouslySetInnerHTML={{__html: obj.name}} ></span>
                  </div>)
                }}
              </PlayAudio>}
            </div>
          )
        })}
      </div>


    </div>
  );
};


export default observer(ObjectiveBar)
